const uniqueId = (): string => Math.random().toString(36).substring(2);

export default uniqueId;
